// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".layout-footer[data-v-6bdb0e5a]{width:100%;display:-webkit-box;display:-ms-flexbox;display:flex}.layout-footer-warp[data-v-6bdb0e5a]{margin:auto;color:var(--prev-color-text-secondary);text-align:center}", ""]);
// Exports
module.exports = exports;
